import { render } from "./SearchAutocomplete.vue?vue&type=template&id=788ea481"
import script from "./SearchAutocomplete.vue?vue&type=script&lang=js"
export * from "./SearchAutocomplete.vue?vue&type=script&lang=js"

import "./SearchAutocomplete.vue?vue&type=style&index=0&id=788ea481&lang=css"
script.render = render

export default script